let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cMTbb")).then(() => parcelRequire('52F2e'));